import { fromJS } from 'immutable'

export default fromJS({
  questions: {
    noAlt: 'Lipsește textul alternativ pentru această imagine',
    noAnswers: 'Nu există opțiune de răspuns, dați clic pe Continuare..',
    placeholder: 'Indicați...',
    pleaseSelect: 'Selectați...',
    rotateLandscape: 'Dezactivează blocarea orientării pe telefonul tău și rotește-l în modul peisaj pentru a continua.',
    rotatePortrait: 'Rotește-ți telefonul de la peisaj la portret pentru a continua.',
    ir: {
      selectWebCam:
        'Selectați camera web (dacă este disponibilă) sau dați clic pe „Browse” pentru a încărca din dispozitiv',
      noWebCam: 'Nu s-a detectat niciun webcam',
      accessCamUpload: 'ACCESAȚI CAMERA/ÎNCĂRCAȚI',
      browse: 'RĂSFOIȚI',
      uploadPhoto: 'Încărcați o fotografie',
      camera: 'Web Camera',
      instead: 'în schimb',
      capture: 'FACEȚI FOTOGRAFIA',
      somethingWrong: 'Ne pare rău. Ceva n-a mers bine. Încercați din nou mai târziu.',
      couldntRead: 'Ne pare rău, nu am putut citi codul!',
      couldntProcess: 'Ne pare rău, nu am putut procesa imaginea!',
      inValidCode: 'Please, submit the valid code',
      moveOn: 'Încercați din nou sau trimiteți fotografia și continuați',
      tryAgain: 'Încercați din nou',
      dataReceived: 'Datele au fost primite!',
      enterManually: 'Încercați din nou sau introduceți datele manual mai jos',
      positionQR:
        'Poziționați codul QR în fața camerei pentru a se încadra în cadrul roșu sau încărcați-l din computer.',
      positionQRMobile: 'Poziționați codul QR în fața camerei sau încărcați-l de pe dispozitivul dvs.',
      analyzing: 'Se analizează imaginea, vă rugăm să așteptați',
      submit: 'TRIMITEȚI',
      startOver: 'Începeți din nou',
      allDone: 'Gata!',
      cantAnalyze:
        'Atenție - nu am reușit să afișăm această imagine. Încercați să o trimiteți din nou sau alegeți un alt format de imagine (JPG, PNG, GIF, BMP)',
      wrongFormat:
        'Ne pare rău - acest format de fișier nu este acceptat. Încercați din nou cu un format acceptat (JPG, PNG, GIF, BMP, TIF, PDF, SVG)'
    },
    vr: {
      noWebCam: 'Nu s-a detectat niciun webcam',
      uploadVideo: 'Încărcare videoclip',
      skip: 'Ignorați?',
      accessCamUpload: 'ACCEDI ALLA FOTOCAMERA/CARICAMENTO',
      browse: 'RĂSFOIȚI',
      instead: 'în schimb',
      or: 'sau',
      stopRecording: 'Opriți înregistrarea',
      willBeStopped: 'Înregistrarea se va opri la <b>5 minute</b>',
      stopOnDone: 'Opriți înregistrarea când ați terminat!',
      record: 'ÎNREGISTRAȚI',
      somethingWrong: 'Ne pare rău. Ceva n-a mers bine. Încercați din nou mai târziu.',
      dataReceived: 'Datele au fost primite!',
      microphone: 'Microfonul',
      camera: 'Web Camera',
      selectMicrophone: 'Selectați microfonul',
      selectCam: 'Selectați camera web',
      submit: 'TRIMITEȚI',
      upload: 'ÎNCĂRCARE',
      playback: 'REDARE',
      stopPlayback: 'OPRIRE REDARE',
      startOver: 'Începeți din nou',
      allDone: 'Gata!',
      alternativeRecordSpan:
        'Încărcați un videoclip de pe computer sau dispozitiv.<br/> Alternativ, puteți să înregistrați videoclipul cu un webcam.&nbsp;',
      alrenativeRecordHref: 'puteți să înregistrați videoclipul cu un webcam',
      cantAnalyze:
        'Atenție - nu am reușit să afișăm acest videoclip. Încercați să îl trimiteți din nou sau alegeți un alt format video (MP4, M4V, WEBPM)',
      wrongFormat:
        'Ne pare rău - acest format de fișier nu este acceptat. Încercați din nou cu un format video acceptat (MP4, AVI, M4V, WEBPM, MOV, MKV, MPG, WMV)'
    },
    cjc: {
      choose: 'ALEGEȚI',
      pleaseChoose: 'Vă rugăm să alegeți',
      this: 'ACEASTA',
      one: 'unu',
      myChoice: 'ALEGEREA ME'
    },
    hm: {
      addComment: 'Adăugați un comentariu mai jos',
      commentMandatoryPlaceHolder: 'Adăugați un comentariu obligatoriu...',
      commentOptionalPlaceHolder: 'Adăugați un comentariu opțional...',
      dragPin: 'Trageți pentru a repoziționa (clic lung/atingeți pentru poziționarea precisă a pin-ului).',
      removePin:
        'Trageți în afara imaginii pentru a șterge.Trageți în afara imaginii pentru a șterge.Trageți în afara imaginii pentru a șterge.',
      editComment: 'Dați clic/atingeți pentru a edita comentariul.',
      addPin: 'Trageți pin-ul de pe panoul de control de mai jos și plasați-l într-un loc ales de dvs. pe imagine.',
      addPins:
        'Trageți pin-urile de pe panoul de control de mai jos și plasați-le într-un loc ales de dvs. pe imagine.',
      leavePins: (minPoints, maxPoints) =>
        `Lăsați cel puțin ${minPoints}, dar nu mai mult de ${maxPoints} (de) pin-uri de fiecare fel.`,
      leavePinsAny: (minPoints, maxPoints) =>
        `Lăsați cel puțin ${minPoints}, dar nu mai mult de ${maxPoints} (de) pin-uri.`,
      leavePinsPerPage: (minPoints, maxPoints) =>
        `Lăsați cel puțin ${minPoints}, dar nu mai mult de ${maxPoints} (de) pin-uri.`,
      leavePinsWithOff: maxPoints =>
        `Lăsați cel mult ${maxPoints} pin de fiecare fel sau dați clic pe Continuare pentru a omite acest pas.`,
      leavePinsWithOffAny: maxPoints =>
        `Lăsați cel mult ${maxPoints} pin-uri de fiecare fel sau dați clic pe Continuare pentru a omite.`,
      leavePinsPerPageWithOff: maxPoints =>
        `Nu lăsați mai mult de ${maxPoints} (de) pin-uri sau dați clic pe Continuare pentru a omite.`,
      leavePinWithOff: `Lăsați cel mult 1 pin de fiecare fel sau dați clic pe Continuare pentru a omite acest pas.`,
      leavePinWithOffAny: `Nu lăsați mai mult de un ac de orice fel sau dați clic pe Următorul pentru a sări peste.`,
      leavePinPerPageWithOff: 'Nu lăsați mai mult de 1 pin-uri sau dați clic pe Continuare pentru a omite.',
      leaveExactlyPin: `Lăsați 1 pin din fiecare fel.`,
      leaveExactlyPinAny: `Lăsați un ac de orice fel.`,
      leaveExactlyPinPerPage: 'Lăsați 1 pin.',
      leaveExactlyPins: maxPoints => `Lăsați ${maxPoints} pin-uri de fiecare fel.`,
      leaveExactlyPinsAny: maxPoints => `Lăsați ${maxPoints} pin-uri de fiecare fel.`,
      leaveExactlyPinsPerPage: maxPoints => `Lăsați ${maxPoints} pin-uri.`,
      leaveComment: 'Tastați sub imagine pentru a lăsa comentariul.',
      noAnswers: 'Nu există opțiune de răspuns, dați clic pe Continuare.',
      outOfPins: 'Nu mai aveți pin-uri',
      pinsBehavior:
        'Pe măsură ce vă deplasați pe imagine, veți vedea zone care vor fi evidențiate cu o singură picătură de ac.',
      clusters: 'Veți putea plasa ace numai în aceste zone evidențiate.',
      contentAware: 'Puteți lăsa ace în interiorul sau în afara zonelor evidențiate.'
    },
    mp: {
      expand_note: 'Vă rugăm să treceți peste sau să dați clic pe imagini pentru a le mări',
      rb_note: rows => `Selectați doar 1 răspunsul pentru articolul${rows ? ' de mai jos' : ''}:`,
      cb_note: (min, max, rows) => {
        if (min === max) {
          return `Selectaţi oricare ${min} răspuns${min !== 1 ? 'uri' : ''} pentru articolul${
            rows ? ' de mai jos' : ''
          }:`
        } else if (min > 0 && max < 5000) {
          return `Selectaţi cel puțin ${min} răspuns${
            min !== 1 ? 'ur' : ''
          }, dar nu mai mult de ${max} pentru fiecare punct${rows ? ' de mai jos' : ''}:`
        } else if (5000 === max && min > 0) {
          return `Selectaţi cel puțin ${min} răspuns${min !== 1 ? 'ur' : ''} pentru fiecare punct${
            rows ? ' de mai jos' : ''
          }:`
        } else if (0 === min && max < 5000) {
          return `Selectaţi cel mult ${max} răspuns${max !== 1 ? 'ur' : ''}  pentru fiecare punct${
            rows ? ' de mai jos' : ''
          }:`
        } else {
          return 'Bifați toate opțiunile care se aplică:'
        }
      }
    },
    sh: {
      note: 'Dați clic pe un produs pentru a mări imaginea și adăugați-l la coșul virtual dacă l-ați cumpăra în magazin.',
      amazonNote: 'Faceți clic pe un produs pentru a-l mări și a-l adăuga în coșul dvs. de cumpărături virtual.',
      fullCart: 'Coșul dvs. este plin!!',
      qty: 'CANT.',
      addToCart: 'ADĂUGARE ÎN COȘ',
      added: 'ADĂUGAT',
      deleteFromCart: 'ȘTERGERE',
      emptyCard: 'Coșul dvs. este gol!',
      total: 'Coș',
      each: 'fiecare',
      items: 'articole',
      fullscreen: 'Fullscreen mode',
      closeFullscreen: 'Exit fullscreen',
      clearCart: 'Golire coș',
      next: 'CONTINUARE',
      backToStore: 'Înapoi la magazin',
      na: 'Niciunul/Niciuna dintre cele de mai sus',
      shelfError: (count, products) =>
        `There is no place for ${count !== 1 ? 'these' : 'this'} product${
          count !== 1 ? 's' : ''
        } on the shelves: ${products}!`,
      maxCartCountError: max => `Vă rugăm să adăugați maximum ${max} produse în coș`,
      scrollError: `Vă rugăm să derulați complet la stânga și la dreapta pentru a continua sondajul. `,
      maxSpentError: max => `Vă rugăm să cheltuiți maximum ${max}.`,
      maxProductCountError: max => `Vă rugăm să adăugați în coș maximum o cantitate de ${max} pentru fiecare produs.`
    },
    rb: {
      note: 'Selectaţi numai 1 articol:'
    },
    vo: {
      note: 'Vizionați videoclipul până la sfârșit\n'
    },
    cb: {
      note: (min, max) => {
        if (min === max) {
          return `Selectaţi oricare ${min} articol${min !== 1 ? 'e' : ''}:`
        } else if (min > 0 && max < 5000) {
          return `Selectaţi cel puțin ${min} articol${min !== 1 ? 'e' : ''}, dar nu mai mult de ${max} pe rând:`
        } else if (5000 === max && min > 0) {
          return `Selectaţi cel puțin ${min} articol${min !== 1 ? 'e' : ''}:`
        } else if (0 === min && max < 5000) {
          return `Selectaţi cel puțin ${max} articol${max !== 1 ? 'e' : ''}, dar nu mai mult de ${min} pe rând:`
        } else {
          return 'Bifați toate opțiunile care se aplică:'
        }
      }
    },
    oe: {
      na: 'Nu se aplică',
      note: (min, max, optional) => {
        if (min === max) {
          return `Introduceți ${1 !== min ? 'orice' : 'numai'} ${min} caracter${1 !== min ? 'e' : ''}${
            optional ? ' (opțional)' : ''
          }:`
        } else if (min > 0 && max < 5000) {
          return `Introduceți cel puțin ${min} caracter${1 !== min ? 'e' : ''} dar nu mai mult de  ${max}${
            optional ? ' (opțional)' : ''
          }:`
        } else if (5000 === max && min > 0) {
          return `Introduceți cel puțin ${min} caracter${1 !== min ? 'e' : ''}${optional ? ' (opțional)' : ''}:`
        } else if (0 === min && max < 5000) {
          return `Introduceți cel mult ${max} caracter${1 !== max ? 'e' : ''}${optional ? ' (opțional)' : ''}:`
        } else {
          return ''
        }
      }
    },
    oex: {
      note: 'Completați următoarele câmpuri:'
    },
    mx: {
      note: 'Mutați glisoarele evidențiate pentru a continua',
      dragSlider: 'Trageți spre stânga sau spre dreapta pentru a răspunde.'
    },
    psc: {
      dragLeftRight: 'Trageți spre stânga sau spre dreapta pentru a răspunde.'
    },
    ps: {
      note: value => `Distribuiți ${value} rămase între elementele de mai jos`,
      allDone: `Terminé!`,
      total: `Total:`,
      dragSlider: 'Trageți spre stânga sau spre dreapta pentru a răspunde.'
    },
    cx: {
      note: 'Deschideți folderul depozitar și începeți să introduceți răspunsul pentru a derula automat sau selectați-l manual.'
    },
    ro: {
      note: 'Trageți în sus sau în jos pentru a reordona:'
    },
    md: {
      note1:
        'Dați clic pe/atingeți elementul ales <b>primul</b>.<br/>Dați clic/atingeți din nou pentru a șterge alegerea.',
      note2:
        'Dați clic pe/atingeți elementul ales <b>ultimul</b>.<br/>Dați clic/atingeți din nou pentru a șterge alegerea.',
      note3:
        'Mulțumim! Treceți la întrebarea următoare sau dați clic pe/atingeți orice element neselectat pentru a începe din nou.'
    },
    aro: {
      note: 'Alegeți un element din fiecare pereche:'
    },
    wd: {
      note: 'Asigurați-vă că fiecare dintre valorile următoare este mai mare decât cea anterioară.'
    },
    emd: {
      note: 'Vizionați videoclipul până la sfârșit\n',
      noAnswers: 'Nu există opțiune de răspuns, dați clic pe Continuare.',
      start: 'Dați clic și țineți apăsat pentru a începe',
      resume: 'Dați clic și țineți apăsat pentru a relua',
      continue: 'Ați terminat! <br />Apăsați Pagina următoare pentru a continua',
      continueMobile: 'Ești gata! <br /> Apasă AICI pentru a continua',
      training: {
        session: 'sesiune de instruire',
        note: 'Vă rog să terminați antrenamentul',
        moveLeft: 'Trageți cadranul până la stânga',
        moveBottom: 'Trageți cadranul până jos',
        moveRight: 'Acum, trageți cadranul până la dreapta',
        moveTop: 'Acum, trageți cadranul până sus',
        success: 'Bravo!'
      }
    },
    sft: {
      noAnswers: 'Nu există opțiune de răspuns, dați clic pe Continuare.',
      note: 'Vă rugăm să răspundeți cât mai repede puteți, cu alternativa pe care o simțiți corectă în mod intuitiv',
      finish: 'Ați terminat! <br /> Apăsați Pagina următoare pentru a continua',
      training: {
        start:
          '<p>Această întrebare vă va arăta rapid diferite cuvinte și necesită concentrare. ' +
          'Trebuie să reacționați rapid pentru a răspunde. </p> <p>Gata de antrenament?</p>',
        step1: (touch, mouse, key) =>
          touch
            ? `Apăsați "{buttonLeft}"`
            : (mouse ? `Dați clic pe "{buttonLeft}"` : '') +
              (key && mouse ? ' / ' : '') +
              (key ? `Apăsați tasta „F”` : ''),
        step2: (touch, mouse, key) =>
          touch
            ? `Apăsați "{buttonRight}"`
            : (mouse ? `Dați clic pe "{buttonRight}"` : '') +
              (key && mouse ? ' / ' : '') +
              (key ? `Apăsați tasta „J”` : ''),
        fail: () => 'Prea încet',
        success: () => 'Minunat!',
        finish: () =>
          '<p><strong> Excelent!</strong></p><p>Asigurați-vă că nimic nu<br />' +
          'vă va distrage atenția<br/> în următoarele 2-3 minute. </p><p>Apăsați Pagina următoare când sunteți gata.</p>'
      },
      buttons: {
        start: 'Start',
        yesno: {
          left: 'Da',
          right: 'Nu'
        },
        matches: {
          left: 'Corespunde',
          right: 'Nu corespunde'
        },
        fits: {
          left: 'Se potrivește',
          right: 'Nu se potrivește'
        },
        thumbs: {
          left: '<i class="rfd-ui-button-icon icon-aytmfd-thumbsUp"></i>',
          right: '<i class="rfd-ui-button-icon icon-aytmfd-thumbsDown"></i>'
        }
      }
    }
  }
})
